import { Input } from "antd";
import { useEffect, useRef, useState } from "react";
import AddNewButton from "../../atoms/Buttons/AddNewButton";
import RangePickerField from "../../atoms/RangePickerField";
import SubmitButton from "../../atoms/Buttons/SubmitButton";
import moment from "moment";
import { Link } from "react-router-dom";
import media from "../../../media";
import { useSelector } from "react-redux";
import { listOfExpenseTabItems } from "../../../utils/Constants";

const Searchbar = (props) => {
  const {
    searchClassName,
    searchPlaceholder,
    addNewButtonClassName,
    addNewButtonName,
    href,
    hasSearchButton,
    btnType,
    onButtonClick,
    searchData = [],
    onSearchResult = () => {},
    onFilteredData,
    searchKeys,
    isVisible,
    setIsVisible,
    setShowLoader,
    payload,
    list,
    headers,
    formFields,
    successMessage,
    hasFilter,
    handleMonthRangeChange,
    handleDownloadMWERReport,
    listingStatus,
    isGlSearch,
    onSearchValue,
    searchText = null,
    setSearchText,
    handleStatusChange,
    onSuccess,
    selectedRowKeys,
    deleteOnClick,
  } = props;

  const { Search } = Input;

  //const [searchText, setSearchText] = useState("");
  const startMonth = moment("2023-11", "YYYY-MM");
  const endMonth = moment();

  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState("Select Status");
  let storeRole = useSelector((state) => state.auth.role);
  const disabledDate = (current) => {
    return (
      current &&
      (current < startMonth.startOf("month") ||
        current > endMonth.endOf("month"))
    );
  };
  const initialState = "ALL";
  const dropdownRef = useRef(null);
  const toggleDropdown = () => setOpen(!open);

  const [currentStatus, setCurrentStatus] = useState(initialState);
  const handleSelect = (label, value) => {
    setSelected(label);
    setOpen(false);
    handleTabClick(value);
    if (typeof handleStatusChange === "function") {
      handleStatusChange(value);
    }
  };

  const handleTabClick = (status) => {
    setCurrentStatus(status);
  };
  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (!searchText || typeof searchText !== "string") { // || !searchText?.trim()
      onFilteredData?.(searchData);
    } else {
      const lowerSearch = searchText.toLowerCase();
      const filtered =
        Array.isArray(searchData) && searchData.length
          ? searchData.filter((item) =>
              searchKeys.some((key) => {
                const value = item[key];
                // Convert everything to string for comparison
                const stringValue =
                  value !== null && value !== undefined
                    ? String(value).toLowerCase()
                    : "";

                return stringValue?.includes(lowerSearch);
              })
            )
          : [];
      onFilteredData?.(filtered);
    }
  }, [searchText, searchData]);

  return (
    <div className="row commonSearchWrap">      
      <div className="col-lg-7 text-left">
        <div className="searchFilter">
          <div className="searchBar">
            <Search
              value={searchText || undefined}
              title={searchPlaceholder}
              className={`${searchClassName} ${
                searchText ? "search-value" : ""
              }`}
              placeholder={searchPlaceholder}
              {...(isGlSearch
                ? { onSearch: (value) => onSearchValue(value) }
                : { onChange: (e) => setSearchText(e.target.value) })}
              //onSearch={(value) => setSearchText(value)}
              allowClear
            />
          </div>
          {listingStatus && (
            <div
              className={`custom-dropdown ${
                selected !== "Select Status" ? "has-value" : ""
              }`}
              ref={dropdownRef}
            >
              <button className="dropdown-toggle" onClick={toggleDropdown}>
                {selected}{" "}
                <span className="arrow">
                  {open ? (
                    <img src={media.down.svg} />
                  ) : (
                    <img src={media.down.svg} />
                  )}
                </span>
              </button>

              {open && (
                <ul className="nav nav-tabs nav-tabs-line dropdown-list">
                  {listOfExpenseTabItems(storeRole)
                    .filter((tab) => tab.show)
                    .map((tab) => (
                      <li
                        key={tab.label}
                        className={`nav-item ${
                          selected === tab.label ? "active" : ""
                        }`}
                        onClick={() => {
                          handleSelect(tab.label, tab.onClickValues);
                        }}
                      >
                        <span>{tab.label}</span>
                      </li>
                    ))}
                </ul>
              )}
            </div>
          )}
          {hasFilter && (
            <div className="d-flex justify-content-between">
              <div className="card-toolbar d-flex m-0">
                <div className="bg-gray-200 border  mr-5 rounded">
                  <RangePickerField
                    picker="month"
                    format="MMM YYYY"
                    disabledDate={disabledDate}
                    onChange={handleMonthRangeChange}
                    className="border-0 h-100 rangepicker"
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="col-lg-5 text-right">
        {hasSearchButton && (
          <AddNewButton
            addNewButtonClassName={addNewButtonClassName}
            addNewButtonName={addNewButtonName}
            href={href}
            btnType={btnType}
            onClick={onButtonClick}
            isVisible={isVisible}
            setIsVisible={setIsVisible}
            setShowLoader={setShowLoader}
            payload={payload}
            list={list}
            headers={headers}
            formFields={formFields}
            successMessage={successMessage}
            onSuccess={onSuccess}
            selectedRowKeys={selectedRowKeys}
            deleteOnClick={deleteOnClick}
          />
        )}

        {hasFilter && (
          <div className="d-flex justify-content-end">
            <div className="card-toolbar d-flex m-0">
              <Link
                onClick={handleDownloadMWERReport}
                className="btn mx-auto px-5 py-2 defaultbutton rounded-lg down-excel"
              >
                <img src={media.download.svg} /> Download Excel
              </Link>
              {/* <SubmitButton
                  ky="downloadMWERReport"
                  type="primary"
                  htmlType=""
                  submitName="Download Excel"
                  className="btn mx-auto px-5 py-2 defaultbutton rounded-lg export-excel-button download-button"
                  onClick={handleDownloadMWERReport}
                /> */}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Searchbar;
